/**
 * EventBus - Centralized event management system
 * Allows components to communicate without tight coupling
 */
export class EventBus {
    constructor() {
        this.events = {};
    }

    /**
     * Subscribe to an event
     */
    on(event, callback) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(callback);
        return this;
    }

    /**
     * Unsubscribe from an event
     */
    off(event, callback) {
        if (!this.events[event]) return this;
        
        if (!callback) {
            delete this.events[event];
        } else {
            this.events[event] = this.events[event].filter(cb => cb !== callback);
        }
        return this;
    }

    /**
     * Emit an event
     */
    emit(event, data) {
        if (!this.events[event]) return this;
        
        this.events[event].forEach(callback => {
            callback(data);
        });
        return this;
    }

    /**
     * Subscribe to an event once
     */
    once(event, callback) {
        const onceCallback = (data) => {
            callback(data);
            this.off(event, onceCallback);
        };
        return this.on(event, onceCallback);
    }
}

// Export singleton instance
export const eventBus = new EventBus();

